<template>
  <!--
    No BlockFieldset at the root: it would also disable the card headers, so readers could not open
    a card. AccordionCard disables only its body.
  -->
  <div class="project-sales-report-data">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <MobileProjectsSalesReport
      v-else
      :project="project"
      :saveCard="saveCard"
      :reportTemplateImages="project.reportTemplateImages"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MobileProjectsSalesReport from '@/views/Projects/MobileProjectsSalesReport';

/** Number of the unsaved project (ProjectEdit `_new`). */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-sales-report-data ("Sales Protokoll: Erfasste Daten", see feature page
 * projekt-protokolle): the cards, saved per card with "weiter"/"zurück" and the card state toggle,
 * with their photos. The tab has no verification, so no request below the cards. `project` is the
 * block data (`Project.blocks.salesReportData`) with the reference data of the cards.
 */
export default {
  name: 'ProjectSalesReportData',
  components: { MobileProjectsSalesReport },
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
    /** Config of the protocol (`reportProtocols.js`), passed by the tab; not imported here (cycle). */
    protocol: { type: Object, required: true },
  },
  computed: {
    isNewProject() {
      return this.project.number === NEW_PROJECT_NUMBER;
    },
  },
  methods: {
    ...mapActions(['updateProjectSalesReportData']),
    saveCard(input) {
      return this.updateProjectSalesReportData({ projectNumber: this.project.number, input });
    },
  },
};
</script>
